<img
  src="./assets/main_background.webp"
  alt=""
  class="background fixed"
/>
